import Card from '@mui/material/Card';
import { Skeleton } from '@mui/material';
import useStyles from './styles';

type Props = {
    size?: number;
};

const BlockSkeletonUi = (props: Props) => {
    const classes = useStyles();
    const header = [1, 2, 3];
    const cards = [1, 2, 3, 4, 5];

    function generateHeader() {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignSelf: 'center' }}>
                <div style={{ paddingLeft: '32px' }}></div>
                {header?.map((item) => {
                    return (
                        <div style={{ paddingRight: '24px' }} key={`header-${item}`}>
                            <Skeleton animation={false} height={10} width="160px" />
                        </div>
                    );
                })}
            </div>
        );
    }

    function generateCards() {
        return cards?.map((index) => {
            return (
                <Card className={classes.card} key={`card-${index}`}>
                    <Skeleton animation={false} width="120px" />
                    <div style={{ paddingTop: '8px' }}>
                        <Skeleton animation="wave" />
                        <Skeleton animation="wave" />
                        <Skeleton animation="wave" />
                    </div>
                </Card>
            );
        });
    }

    return (
        <div className={classes.container} style={{ flexDirection: 'column' }}>
            {/* header */}
            <div
                className="header-wrapper upper-wrapper"
                style={{ width: '100%', height: '72px', backgroundColor: '#d4d8dd', display: 'flex', margin: '24px 0' }}
            >
                {generateHeader()}
            </div>
            {/* navbar */}
            <div className="lower-wrapper" style={{ display: 'flex', width: '100%' }}>
                <div
                    className="navbar"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: '#d4d8dd',
                        width: '48px',
                        height: '100%',
                        marginRight: '32px',
                    }}
                />
                <div
                    className="body-wrapper"
                    style={{ display: 'flex', flexDirection: 'column', height: '100vh', alignSelf: 'flex-start', width: '100%' }}
                >
                    {/* cardwrapper */}
                    <div className="card-wrapper" style={{ width: '100%', height: '100%', backgroundColor: '#e7e9ec' }}>
                        <div className={classes.cardWrapper}>{generateCards()}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlockSkeletonUi;
